module.exports = __webpack_public_path__ + "static/media/logo-pacheco.f61c2b70.png";